<template>
  <div class="phone-validate">
    <div>
      <step-header></step-header>
    </div>
    <div class="form-container">
      <div class="title-phone">输入QQ号和手机号</div>
      <div class="form-validate">
        <el-form :model="validateFormPhone" :rules="phoneRules" ref="validateFormPhone">
          <el-form-item prop="qq" label="* QQ号码：" class="form-item-qq">
            <el-input v-model="validateFormPhone.qq" placeholder="请输入登录所用QQ账号" :maxlength="20"></el-input>
            <div class="QQ-info" v-if="isValidQQ">请务必填写准确，否则将影响后续服务调用</div>
          </el-form-item>
          <el-form-item prop="phone" label="* 电话号码：">
            <el-input v-model="validateFormPhone.phone" placeholder="请输入11位手机号码" :maxlength="11"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="next-step-btn">
        <button class="c-btn-add" @click="handleSubmitForm" >
          <span class="text">下一步</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/common/api';
import StepHeader from '../common/StepHeader';
import * as actionTypes from '@/store/open/action-types';
import ValidateTransferHelper from '@/components/open/common/ValidateTransferHelper';
export default {
  name: 'phoen',
  components: {
    StepHeader
  },
  data() {
    return {
      validateFormPhone: {
        phone: null,
        qq: null,
        code: '123456'
      },
      isValidQQ: true,
      phoneNumberIsvalidate: false,
      phoneRules: {
        qq: [{
          validator: this.validateQQ,
          trigger: ['blur', 'change']
        }],
        phone: [{
          validator: this.validatePhone,
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  methods: {
    validateQQ(rule, value, callback) {
      let pattern = /^[0-9]*$/;
      this.isValidQQ = true;
      if (value == null || value.length === 0) {
        this.isValidQQ = false;
        return callback(new Error('请输入QQ号'));
      }
      if (!pattern.test(value)) {
        this.isValidQQ = false;
        return callback(new Error('请输入正确的QQ号码'));
      }
      callback();
    },
    validatePhone(rule, value, callback) {
      let pattern = /\d{11}/;
      this.phoneNumberIsvalidate = false;
      if (value == null || value.length === 0) {
        return callback(new Error('请输入电话号码'));
      }
      if (!pattern.test(value)) {
        return callback(new Error('请输入正确的电话号码'));
      }
      this.phoneNumberIsvalidate = true;
      callback();
    },
    handleSubmitForm() {
      this.$refs.validateFormPhone.validate((valid) => {
        if (!valid) {
          return;
        }
        const loading = this.loading();
        let data = this.validateFormPhone;
        this.$loader.post(api.user.YTVERIFY_INFO, data).then((res) => {
          this.$store.dispatch(actionTypes.VALIDATE_USER_PHONE);
          ValidateTransferHelper.transferNext();
        }).finally(() => {
          loading.close();
        });
      });
    }
  }
};
</script>

<style lang="less">
.phone-validate{
  .title-phone{
    height: 118px;
    line-height: 118px;
    width: 360px;
    margin: 0 auto;
    color: #666666;
    font-size: 24px;
    text-align: center;
    background-image: url(./img/title_element_left.png),  url(./img/title_element_right.png);
    background-repeat: no-repeat;
    background-position: 0px center, right center;
  }
  .form-container{
    position: relative;
    background: #ffffff;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.10);
    .form-validate{
      width: 840px;
      font-size: 0;
      .el-form-item{
        margin-bottom: 30px;
        &.form-item-qq {
          margin-bottom: 18px;
          height: 57px;
        }
      }
      .QQ-info{
        color:#F2AB05;
        font-size: 11px;
        line-height: 16px;
        height: 16px;
        margin-top: 6px;
        background-image: url(./img/icon_info_18.png);
        background-repeat: no-repeat;
        background-position: 0 center;
        padding-left: 22px;
      }
      .el-form-item__label{
        color: #666666;
        font-size: 18px;
        margin-right: 18px;
      }
      .el-form-item__content{
        width: 360px;
        height: 40px;
        .el-input__inner{
          height: 40px;
          line-height: 40px;
          border: 1px solid #A2C4F8;
          border-radius: 5px;
        }
      }
      .is-validating .el-form-item__label{
        color:#e94e56;
      }
      .validate-code-input{
        display: inline-block;
        vertical-align: top;
        .el-form-item__content{
          width: 240px;
          margin-left: 322px;
        }
      }
    }
    .get-code{
      position: absolute;
      bottom: 207px;
      left: 572px;
      display: inline-block;
      .validate-btn{
        vertical-align: top;
        width: 110px;
      }
    }
    .next-step-btn{
      text-align: center;
      margin-top: 10px;
      padding-bottom: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/validate/panels/PhoneValidate.vue